import { createSlice } from "@reduxjs/toolkit";

export const productsListSlice = createSlice({
  name: "productsList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedProduct: null,
    filteredRecords: 0,
    isSingleProductLoading: false,
    isLoading: false,
    isAnswerByTechTeam: false,
  },
  reducers: {
    setAllProductsLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleProductsLoadingState: (state, action) => {
      state.isSingleProductLoading = true;
    },
    loadAllProducts: (state, action) => {
      const listObj = {};
      action.payload.products.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.products.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleProduct: (state, action) => {
      state.selectedProduct =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleProductLoading = false;
    },
  },
});

export const {
  setAllProductsLoadingState,
  setSingleProductsLoadingState,
  loadAllProducts,
  loadSingleProduct,
} = productsListSlice.actions;

export default productsListSlice.reducer;
